import { render, staticRenderFns } from "./TableTypeCustomFieldUser.vue?vue&type=template&id=d2dcbdfa"
import script from "./TableTypeCustomFieldUser.vue?vue&type=script&lang=js"
export * from "./TableTypeCustomFieldUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports